import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {ISimplePresentation, SimplePresentationRunner} from "../../core/winpresentation/SimplePresentationRunner";
import {KMDSpecialRowXWaysExpandRunner} from "../presentationRunners/KMDSpecialRowXWaysExpandRunner";
import {KMDWinRunner} from "../presentationRunners/KMDWinRunner";
import {KMDFSIntroRunner} from "../presentationRunners/KMDFSIntroRunner";
import {KMDFSOutroRunner} from "../presentationRunners/KMDFSOutroRunner";
import {KennethMustDie} from "../KennethMustDie";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {KMDSFSIntroRunner} from "../presentationRunners/KMDSFSIntroRunner";
import {KMDSFSOutroRunner} from "../presentationRunners/KMDSFSOutroRunner";
import {KMDXWaysRevealRunner} from "../presentationRunners/KMDXWaysRevealRunner";
import {KMDBigWinRunner} from "../presentationRunners/KMDBigWinRunner";
import {KMDNormalWinRunner} from "../presentationRunners/KMDNormalWinRunner";
import {KMDSpecialRowXNudgeRunner} from "../presentationRunners/KMDSpecialRowXNudgeRunner";
import {KMDS2FeatureTransform} from "../presentationRunners/KMDS2FeatureTransform";
import {KMDS1FeatureTransform} from "../presentationRunners/KMDS1FeatureTransform";
import {KMDWinCapRunner} from "../presentationRunners/KMDWinCapRunner";
import {KMDM1M2SparkRunner} from "../presentationRunners/KMDM1M2SparkRunner";
import {KMDCFSIntroRunner} from "../presentationRunners/KMDCFSIntroRunner";
import {KMDCFSOutroRunner} from "../presentationRunners/KMDCFSOutroRunner";
import {KMDNormalBetWaysWinRunner} from "../presentationRunners/KMDNormalBetWaysWinRunner";
import {KMDMainReelsXWaysExpandRunner} from "../presentationRunners/KMDMainReelsXWaysExpandRunner";
import {KMDMainReelsXNudgeRunner} from "../presentationRunners/KMDMainReelsXNudgeRunner";
import {KMDXHoleRunner} from "../presentationRunners/KMDXHoleRunner";

export class KMDWinPresentation implements FlowStatePresentation {

    private readonly _presentations: ISimplePresentation[];
    private _flowStateController: FlowStateController;
    private _isFinished: boolean;

    constructor() {
        this._presentations = [
            new KMDXHoleRunner(),
            new KMDS1FeatureTransform(),
            new KMDS2FeatureTransform(),
            new KMDMainReelsXWaysExpandRunner(),
            new KMDMainReelsXNudgeRunner(),
            new KMDSpecialRowXWaysExpandRunner(),
            new KMDSpecialRowXNudgeRunner(),
            new KMDXWaysRevealRunner(),
            new KMDNormalBetWaysWinRunner(),
            new KMDM1M2SparkRunner(),
            new KMDWinRunner(),
            new KMDNormalWinRunner(),
            new KMDBigWinRunner(),
            new KMDWinCapRunner(),
            new KMDFSIntroRunner(),
            new KMDFSOutroRunner(),
            new KMDCFSIntroRunner(),
            new KMDCFSOutroRunner(),
            new KMDSFSIntroRunner(),
            new KMDSFSOutroRunner()
        ];
    }

    public start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;
        this._isFinished = false;

        if (KennethMustDie.model.gameData.mode.indexOf("AVALANCHE") === -1) {
            KennethMustDie.reelView.reelModels.forEach((reel: SimpleReelModel) => {
                reel.removeBufferSymbolsFromStopSymbols();
            });
        }

        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    private complete(): void {
        // #570
        if (this._isFinished) {
            return;
        }

        this._isFinished = true;
        this._flowStateController.finish();
    }
}